import { FiAlertCircle, FiFileText } from "react-icons/fi";

export default function ReportState({ type = "loading" }) {

  if (type === "loading") {
    return (
      <div className="report-state loading">
        <div className="loader"></div>
        <h2>Generando informe...</h2>
        <p>Estamos procesando la información, esto puede tardar unos segundos.</p>

        <div className="skeleton-box">
          <div className="skeleton-line"></div>
          <div className="skeleton-line short"></div>
          <div className="skeleton-line"></div>
        </div>
      </div>
    );
  }

  if (type === "empty") {
    return (
      <div className="report-state empty">
        <FiFileText size={50} />
        <h2>Informe no encontrado</h2>
        <p>
          El informe que buscas no existe o no ha sido publicado.
        </p>
      </div>
    );
  }

  if (type === "error") {
    return (
      <div className="report-state error">
        <FiAlertCircle size={50} />
        <h2>Ocurrió un error</h2>
        <p>No pudimos cargar el informe. Intenta nuevamente.</p>
      </div>
    );
  }

  return null;
}